(()=>{
  'use strict';
  const productId=()=>String(new URL(location.href).searchParams.get('draft_product')||window.FultonsPriceTrial?.productId||'');
  function refresh(section){
    const pid=productId(),models=window.FultonsSideboardDrawings?.[pid];
    const configs=window.FultonsCalligarisSeating?.products?.[pid];
    const select=section.querySelector('#FultonsCalligarisExactSize');
    if(!models||!configs||!select)return;
    section.classList.add('fce-sideboard');
    for(const [i,c] of configs.entries()){
      const label=models[c.modelCode]?.displayLabel;
      if(label&&select.options[i]&&select.options[i].textContent!==label)select.options[i].textContent=label;
    }
    const current=configs[Number(select.value)],details=models[current?.modelCode];
    const drawing=section.querySelector('.fce-drawing'),caption=drawing?.querySelector('figcaption'),image=drawing?.querySelector('img');
    if(!details||!image||!caption)return;
    drawing.hidden=false;
    if(image.getAttribute('src')!==details.thumbnail)image.src=details.thumbnail;
    if(image.alt!==details.thumbnailAlt)image.alt=details.thumbnailAlt;
    const text=[details.drawingCaption,details.drawingNote].filter(Boolean).join(' · ');
    if(caption.textContent!==text)caption.textContent=text;
    let link=drawing.querySelector('.fce-drawing-enlarge');
    if(!link){link=document.createElement('a');link.className='fce-drawing-enlarge';link.target='_blank';link.rel='noopener';link.textContent='Enlarge line drawing';drawing.append(link);}
    if(link.getAttribute('href')!==details.thumbnail)link.href=details.thumbnail;
    link.setAttribute('aria-label','Enlarge line drawing for '+current.modelCode);
    if(!select.dataset.sideboardDrawing){select.dataset.sideboardDrawing='true';select.addEventListener('change',()=>refresh(section));}
    const sizeLabel=section.querySelector('label[for="FultonsCalligarisExactSize"]');
    if(sizeLabel&&sizeLabel.textContent!=='1. Size and layout')sizeLabel.textContent='1. Size and layout';
    let note=section.querySelector('.fce-sideboard-note');
    if(!note){note=document.createElement('p');note.className='fce-sideboard-note';drawing.after(note);}
    const message=current.modelCode.includes('MTO')?'Made-to-order ceramic tops are priced by category. Please confirm your chosen finish with the showroom.':'';
    if(note.textContent!==message)note.textContent=message;note.hidden=!message;
    if(pid==='15888854090111'&&!document.querySelector('#FultonsEnquiry form')){
      let enquiry=section.querySelector('.fce-enquire');
      if(enquiry?.tagName==='BUTTON'){const anchor=document.createElement('a');anchor.className=enquiry.className;anchor.textContent=enquiry.textContent;enquiry.replaceWith(anchor);enquiry=anchor;}
      if(enquiry){
        const finishes=current.roles.map((role,i)=>{const key=section.querySelector('#FultonsCalligarisFinish'+i)?.value;const f=window.FultonsCalligarisSeating.finishes[key];return f?role+': '+f.label:'';}).filter(Boolean);
        const amount=Number(section.dataset.selectedPrice);
        const choice=['Horizon Sideboard',details.displayLabel,...finishes,amount?'£'+amount.toLocaleString('en-GB'):'Price on request'].join(' — ');
        const url=new URL('/pages/contact-fultons-preview',location.origin);url.searchParams.set('view','fultons-contact-preview');url.searchParams.set('preview_theme_id','199663649151');url.searchParams.set('product',choice);
        if(enquiry.getAttribute('href')!==url.href)enquiry.href=url.href;
      }
    }
  }
  function scan(){if(!window.FultonsSideboardDrawings?.[productId()])return;document.querySelectorAll('.fce').forEach(refresh);}
  let queued=false;
  const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;scan();});};
  function start(){scan();const main=document.querySelector('#MainContent');if(main)new MutationObserver(schedule).observe(main,{childList:true,subtree:true});}
  document.addEventListener('fultons:catalogue-updated',schedule);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
